import type { AdapterError } from '@azure/communication-react';

import type { PushType } from './notification';

export type AdvocateInChat = {
  advocate_id: string;
  name: string;
  img_url: string | null;
  service_provider_organization_id: string | null;
};

export type ChatUserConn = {
  token: string;
  communicationUserId: string;
  endpointUrl: string;
  threadId: string;
  displayName: string;
  firstAdvocateMsgSent?: boolean;
  lastGuestMsgTime?: number;
  advocate_unavailable?: boolean;
  guestAreaName?: string;
};

export type ChatData = ChatUserConn & {
  type?: PushType;
  chat_id?: string;
};

type CommonChatEndedBy =
  | 'Guest'
  | 'Advocate'
  | 'GuestTimeout'
  | 'AdvocateTimeout'
  | 'AdvocateDecline'
  | 'CancelledByGuest'
  | 'GuestReportedAbuse';
export type GuestChatEndedBy = CommonChatEndedBy | 'AdvocateLeftChat' | 'GuestQuickExit';
export type AdvocateChatEndedBy = CommonChatEndedBy | 'GuestLeftChat' | 'AdvocateReportedAbuse' | 'ErrorStartingChat';

export interface ChatAdapterError extends AdapterError {
  innerError: Error & { statusCode?: number };
}

export const GUEST_COMPONENT = {
  ADVOCATE_SELECT: 'AdvocateSelect',
  CHAT: 'GuestChat',
  CHAT_SESSION_ERROR: 'GuestChatSessionError',
  DART_CHAT_SESSION_ERROR: 'GuestDartChatSessionError',
} as const;

export type GUEST_COMPONENT = (typeof GUEST_COMPONENT)[keyof typeof GUEST_COMPONENT];

export const ChatPage = {
  LEPS: 'chat',
  SERVICES: 'services',
} as const;

export type ChatPage = (typeof ChatPage)[keyof typeof ChatPage];
